import { jsx, jsxs } from "react/jsx-runtime";
import { Badge, Tooltip } from "@pcln/horizon";
import "react";
const Vibes = ({ vibes, hotelId })=>{
    if (0 === vibes.length) return null;
    return /*#__PURE__*/ jsx("div", {
        className: "relative flex gap-1 py-1",
        children: vibes.map((vibes, index)=>/*#__PURE__*/ jsx(Tooltip, {
                defaultOpen: true,
                closeDelay: 5,
                className: "relative",
                color: "neutral",
                align: "center",
                triggerNode: /*#__PURE__*/ jsxs(Badge, {
                    palette: "success",
                    emphasis: "medium",
                    size: "sm",
                    children: [
                        ' ',
                        vibes.primaryVibe,
                        ' '
                    ]
                }),
                children: /*#__PURE__*/ jsx("div", {
                    className: "bg-neutral-3 text-neutral-11 text-body3 z-10 px-2 py-1",
                    style: {
                        zIndex: 9999,
                        background: '#fff'
                    },
                    children: vibes.vibeDescription
                })
            }, `${hotelId}-${vibes.vibeDescription}-${index}`))
    });
};
const Vibes_Vibes = Vibes;
export { Vibes_Vibes as default };
